import { Expose, Type } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";

export class HouseholdCoverage extends BaseModel {
    @Expose() id = "";
    @Expose() title = "";
    @Expose() description = "";
    @Expose() insuredAmount = 0;
    @Expose() insuredAmountPEN = 0;
    @Expose() deductible = "";
    @Expose() coverage = "";
    @Expose()
    @Type(() => HouseholdCoverage)
    items: HouseholdCoverage[] = [];
}
